// extracted by mini-css-extract-plugin
export default {"postTable":"_1QqY1_D6OJ_sOCIwsnVS_p","actions":"_3lMQ9xcUmkUIxv2Xasb2Pw","buttonBar":"stxtMPu-cEo5EALSTC2hy"};